import {createStore} from 'vuex';
export const FYGR_COMPANY = 'FYGR_COMPANY';
import app from '@/store/app';
import assistedCategorization from '@/store/assistedCategorization';
import bank from '@/store/bank';
import invoices from '@/store/invoices';
import user from '@/store/user';
import billing from '@/store/billing';
import subscription from '@/store/subscription';
import company from '@/store/company';
import provider from '@/store/provider';
import oauth from '@/store/oauth';
import tracking from '@/store/tracking';
import vat from '@/store/vat';
import partner from '@/store/partner';
import translations from '@/store/translations';
import treasuryInvestment from '@/store/treasuryInvestment';
import analytics from '@/store/analytics';
import counterparties from '@/store/counterparties';
import cards from '@/store/cards';
import eBanking from '@/store/eBanking';
import onboarding from '@/store/onboarding';
import validation3ds from '@/store/validation3ds';
import notifications from '@/store/notifications';
import paywall from '@/store/paywall';
import accounting from '@/store/accounting';
import connectedApps from '@/store/connectedApps';
import patTokens from '@/store/patTokens';
import ebicsAdmin from '@/store/ebicsAdmin';

export default createStore({
  state: {
    companyId: localStorage.getItem(FYGR_COMPANY) || null,
  },
  mutations: {
    setCompanyId(state, id) {
      state.companyId = id;
    },
  },
  actions: {
    actionSetCompanyId({commit}) {
      const id = localStorage.getItem(FYGR_COMPANY);
      if (id) commit('setCompanyId', id);
    },
  },
  modules: {
    app,
    assistedCategorization,
    bank,
    billing,
    company,
    provider,
    invoices,
    subscription,
    user,
    oauth,
    tracking,
    vat,
    partner,
    translations,
    treasuryInvestment,
    analytics,
    counterparties,
    cards,
    eBanking,
    onboarding,
    validation3ds,
    notifications,
    paywall,
    accounting,
    patTokens,
    connectedApps,
    ebicsAdmin,
  },
});
